// Import external
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as md5 from 'md5';

/**
 * Avatar generator
 */
@Injectable()
export class AvatarService {

    private InitialsLength = 2;
    private LuminanceThreshold = 180;

    constructor() {
    }

    /**
     * Generate initials from name
     * @param name string
     * @returns {string}
     */
    public getInitials(name: string): string {
        // Split name and take only firsts elements
        const split = _.split(name, / |,|\.|-|_/g, this.InitialsLength);

        // Get first character in uppercase of each elements
        const chars = _.map(split, (item) => {
            return item.charAt(0).toUpperCase();
        });

        // Join everything and return
        return _.join(chars, '');
    }

    /**
     * Generate color from name
     * @param name string
     * @returns {string}
     */
    public getColor(name: string) {
        // Convert name to hexadecimal hash
        const nameHash = md5(name);

        // Pick-up colors
        let redInt = _.parseInt(nameHash.substr(0, 2), 16);
        let greenInt = _.parseInt(nameHash.substr(2, 2), 16);
        let blueInt = _.parseInt(nameHash.substr(4, 2), 16);

        // Calculate luminance
        const luminance = 0.2126 * redInt + 0.7152 * greenInt + 0.0722 * blueInt;

        // Darken high luminance colors
        if (luminance > this.LuminanceThreshold) {
            const darken = 255 - this.LuminanceThreshold;

            redInt = Math.round(redInt - (darken * 0.2126));
            redInt = redInt < 0 ? 0 : redInt;
            greenInt = Math.round(greenInt - (darken * 0.7152));
            greenInt = greenInt < 0 ? 0 : greenInt;
            blueInt = Math.round(blueInt - (darken * 0.0722));
            blueInt = blueInt < 0 ? 0 : blueInt;
        }

        // Convert colors to 2 digits hexadecimal
        let redHex = redInt.toString(16);
        redHex = redHex.length === 1 ? '0' + redHex : redHex;
        let greenHex = greenInt.toString(16);
        greenHex = greenHex.length === 1 ? '0' + greenHex : greenHex;
        let blueHex = blueInt.toString(16);
        blueHex = blueHex.length === 1 ? '0' + blueHex : blueHex;

        // Return ready to use hexadecimal color
        return '#' + redHex + greenHex + blueHex;
    }
}
